// extracted by mini-css-extract-plugin
export default {"root":"_3WhlF","link-overlay":"_16TQa","linkOverlay":"_16TQa"};